// extracted by mini-css-extract-plugin
module.exports = {"main-component":"historySvg_main-component__3jzKR"};